module.exports = __webpack_public_path__ + "img/户部寨镇.6757342c.png";